/* Style Mobo — Wishlist (localStorage) */

const SM_WISHLIST_KEY = 'sm_wishlist_v1';

const SMWishlist = {
  _items: null,

  get items() {
    if (!this._items) {
      try {
        this._items = JSON.parse(localStorage.getItem(SM_WISHLIST_KEY) || '[]');
      } catch {
        this._items = [];
      }
    }
    return this._items;
  },

  save() {
    try {
      localStorage.setItem(SM_WISHLIST_KEY, JSON.stringify(this._items));
    } catch {}
    this._emit();
  },

  has(productId) {
    return this.items.includes(String(productId));
  },

  add(productId, meta = {}) {
    const id = String(productId);
    if (!this.has(id)) {
      this._items.push(id);
      this.save();
    }
  },

  remove(productId) {
    const id = String(productId);
    this._items = this._items.filter(i => i !== id);
    this.save();
  },

  toggle(productId, meta = {}) {
    if (this.has(productId)) {
      this.remove(productId);
      return false;
    } else {
      this.add(productId, meta);
      return true;
    }
  },

  count() {
    return this.items.length;
  },

  _emit() {
    document.dispatchEvent(new CustomEvent('sm:wishlist:updated', {
      detail: { items: this.items, count: this.items.length }
    }));
  }
};

/* Wishlist button web component */
class SMWishlistButton extends HTMLElement {
  connectedCallback() {
    this._productId = this.dataset.productId;
    this._update();
    this.addEventListener('click', () => this._toggle());
    document.addEventListener('sm:wishlist:updated', () => this._update());
  }

  _update() {
    const wishlisted = SMWishlist.has(this._productId);
    this.classList.toggle('is-wishlisted', wishlisted);
    this.setAttribute('aria-label', wishlisted ? 'Remove from wishlist' : 'Add to wishlist');
    this.setAttribute('aria-pressed', wishlisted ? 'true' : 'false');
    const svg = this.querySelector('svg path');
    if (svg) {
      svg.setAttribute('fill', wishlisted ? '#FF3B30' : 'none');
      svg.setAttribute('stroke', wishlisted ? '#FF3B30' : 'currentColor');
    }
  }

  _toggle() {
    const added = SMWishlist.toggle(this._productId);
    this._bounce();
    this._showToast(added);
  }

  _bounce() {
    this.animate([
      { transform: 'scale(1)' },
      { transform: 'scale(1.35)' },
      { transform: 'scale(0.9)' },
      { transform: 'scale(1.1)' },
      { transform: 'scale(1)' }
    ], { duration: 400, easing: 'ease-out' });
  }

  _showToast(added) {
    SMToast.show(added ? '❤️ Added to wishlist' : 'Removed from wishlist');
  }
}
customElements.define('sm-wishlist-btn', SMWishlistButton);

/* Update tabbar wishlist count */
function updateWishlistTabCount() {
  document.querySelectorAll('[data-sm-wishlist-count]').forEach(el => {
    el.setAttribute('data-count', SMWishlist.count());
    el.textContent = SMWishlist.count() || '';
  });
}
document.addEventListener('sm:wishlist:updated', updateWishlistTabCount);
document.addEventListener('DOMContentLoaded', updateWishlistTabCount);

window.SMWishlist = SMWishlist;
